'use es6';

export const LAPTOPHEIGHT = '900px';
export const TABLETWIDTH = '768px';
export const DESKTOPMAXWIDTH = '1160px';